import React from 'react';
import { Link } from 'react-router-dom';

export function CheckoutCancelPage() {
  return (
    <div style={{ maxWidth: 600, margin: '4rem auto', textAlign: 'center', padding: '2rem' }}>
      <h1>Checkout cancelled</h1>
      <p>No charges were made. You can subscribe whenever you're ready.</p>
      <Link to="/" style={{ color: '#0070f3' }}>Back to markets</Link>
    </div>
  );
}
